import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

interface IContext {
    /** Пользователю можно войти в конференцию */
    isUserAllowedToEnterTheConference: boolean;
    /** Установка состояния "Пользователю можно войти в конференцию" */
    setIsUserAllowedToEnterTheConference: React.Dispatch<React.SetStateAction<boolean>>;
}

const Context = createContext<IContext>({
    isUserAllowedToEnterTheConference: false,
    setIsUserAllowedToEnterTheConference: () => undefined,
});

export const usePreparationContext = () => useContext(Context);

const PreparationContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [state, setState] = useState<IContext['isUserAllowedToEnterTheConference']>(false);

    const contextValue = useMemo<IContext>(
        () => ({
            isUserAllowedToEnterTheConference: state,
            setIsUserAllowedToEnterTheConference: setState,
        }),
        [state],
    );

    return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export default PreparationContextProvider;
